<template>
    <v-container ma-0 pa-0>
        <v-combobox
            contenteditable="true"
            @dragenter="dragEnterCountryCombo()"
            @dragleave="dragLeaveCountryCombo()"
            @drop.prevent="dropCountryCountryCombo()"
            v-bind:class="{ active: isActive }"
            v-model="country"
            :items="get_ListOfCountries()"
            :label="label"
            prepend-icon="mdi-flag"
            append-icon="mdi-water"
            clearable
            chips>
        </v-combobox>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'countriescombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> created');
            eventBus.$on('dragendhotelslist', this.onDragend_InSelectedHotelList);

        }, // eo function  created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> mounted');
            this.set_Country();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> beforeDestroy');
            eventBus.$off('dragendhotelslist', this.onDragend_InSelectedHotelList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                country: null,
                // >>> --------------------------
                isActive: false, // DnD highlight
                // >>> --------------------------
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            value() {

                this.set_Country();

            }, // eo value()

            country(value) {

                this.$emit('input', value);

            }, // eo base()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Countries',
            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /*******************************************************************
            * onDragend_InSelectedHotelList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedHotelList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> onDragend_InSelectedHotelList');
                this.country = params.countryName; // set dropped country

            }, // eo function onDragend_InSelectedHotelList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * set_Country()
            *
            * Desc: Set Editor to Value. Emit 'countrieschanged' to HotelsCombo.
            * Note:
            *
            */
            set_Country: function() {

                let me = this,
                    countryId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> set_Country');
                me.country = this.value;                                        // a) set

                countryId = this.get_CountryId(me.country);                     // b) emit
                if (countryId !== undefined) {
                    eventBus.$emit('countrieschanged', { countryId: countryId });
                }

            }, // eo function set_Country()



            /*******************************************************************
            * Getters:
            *******************************************************************/
            /*******************************************************************
            * get_ListOfCountries()
            *
            * Desc: Returns List of Countries.
            * Note: From State.
            *
            */
            get_ListOfCountries: function() {

                let me = this,
                    countries = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> get_ListOfCountries');
                this.get_Countries.forEach((country, i) => {
                    countries.push(country.name);
                });


                return countries;

            }, // eo function get_ListOfCountries()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_CountryId()
            *
            * Desc: Return Country ID.
            * Note:
            *
            * @param {String} searchedCountry ()
            */
            get_CountryId: function(searchedCountry) {

                let me = this,
                    countryId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> get_CountryId');
                if (searchedCountry) {
                    countryId = this.get_Countries.find(country => country.name === searchedCountry);
                    if (countryId) {
                        return countryId.id;
                    } else {
                        return null;
                    }
                }

            }, // eo function get_CountryId()




            /******************************************************************* 'Listeners - DnD'
            * Drag&Drop (DnD):
            *******************************************************************/
            /*******************************************************************
            * dragEnterCountryCombo()
            *
            * Desc: Drop enters CountryCombo.
            * Note:
            *
            */
            dragEnterCountryCombo: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> dragEnterCountryCombo');
                this.isActive = true;

            }, // eo function dragEnterCountryCombo()

            /*******************************************************************
            * dragLeaveCountryCombo()
            *
            * Desc: Drop leaves CountryCombo.
            * Note:
            *
            */
            dragLeaveCountryCombo: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> dragLeaveCountryCombo');
                this.isActive = false;

            }, // eo function dragLeaveCountryCombo()


            /*******************************************************************
            * dropCountryCountryCombo()
            *
            * Desc: Drop onto CountryCombo.
            * Note:
            * TODO: Some var = true in Case of droped? Maybe Later.
            * TODO: Problem is: U have 2 Dropzones.
            *
            */
            dropCountryCountryCombo: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CountriesCombo.vue >>> dropCountryCountryCombo');
                this.isActive = false;

            }, // eo function dropCountryCountryCombo()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    /* DnD Background to highlight it */
    .active {
        background-color: #ab3b7a !important;
    }
</style>